export default function XIcon({
  width = 8,
  height = 8,
  fill = 'currentColor',
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.221517 0.0188599C0.141562 0.0481597 0.0446027 0.149494 0.0170009 0.232585C-0.0104522 0.315242 -0.00339987 0.417518 0.0350592 0.494746C0.0546915 0.534184 0.547843 1.03543 1.78705 2.27551L3.51171 4.0014L1.78705 5.72729C0.547843 6.96737 0.0546915 7.46862 0.0350592 7.50805C-0.0482047 7.67525 0.021909 7.88092 0.191721 7.96764C0.275097 8.01023 0.412449 8.01086 0.493854 7.96905C0.533379 7.94877 1.05256 7.43784 2.27551 6.21575L4.0014 4.49109L5.72729 6.21575C6.95024 7.43784 7.46942 7.94877 7.50895 7.96905C7.58935 8.01035 7.72778 8.01019 7.80892 7.96872C7.87964 7.93258 7.93094 7.88073 7.96955 7.80641C8.0102 7.72814 8.00997 7.58862 7.96905 7.50895C7.94877 7.46942 7.43784 6.95024 6.21575 5.72729L4.49109 4.0014L6.21575 2.27551C7.43784 1.05256 7.94877 0.533379 7.96905 0.493854C8.01086 0.412449 8.01023 0.275097 7.96764 0.191721C7.88092 0.021909 7.67525 -0.0482047 7.50805 0.0350592C7.46862 0.0546915 6.96737 0.547843 5.72729 1.78705L4.0014 3.51171L2.27551 1.78705C1.02008 0.532511 0.53442 0.054803 0.493854 0.0345757C0.420827 -0.0018383 0.297406 -0.00896497 0.221517 0.0188599Z'
        fill={fill}
      />
    </svg>
  );
}
